import { createAction, props } from '@ngrx/store';
import { DossierLogs } from './dossier-logs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier log',
    props<{ dossierId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier log success', 
    props<{ listData: DossierLogs[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier log failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier log',
);
